import { Button, Checkbox, Col, Input, Modal, Row, Space, Table } from 'antd';
import { Dropdown, InputGroup } from 'react-bootstrap';
import { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import CreateCancel from 'components/forms/CreateCancel';
import Excel from 'components/table/excel';
import CustomPagination from 'components/table/pagination';
import ModalDelete from 'components/tabel/ModalDelete';
import DashboardContext from 'Context';
import FormBusinessCompany from './FormBusinessCompany';
import toaster from 'helper/toaster';

export default function BusinessCompany() {
  const history = useHistory();
  const {
    SohwaddFrom,
    handelAdd,
    handelEdit,
    urldashboard,
    authentication,
    handelerrors,
  } = useContext(DashboardContext);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [headers, setHeaders] = useState([]);
  const [rowId, setRowId] = useState('');
  const [record, setRecord] = useState({});
  const [searchValue, setSearchValue] = useState('');
  const [totalRecord, setTotalRecord] = useState(0);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
  });
  const [favServices, setFavServices] = useState([]);
  const [favServicesLoading, setFavServicesLoading] = useState(false);
  const [submitFavServicesLoading, setSubmitFavServicesLoading] =
    useState(false);
  // action modals
  const [deleteModal, setDeleteModal] = useState(false);
  const [favServicesModal, setFavServicesModal] = useState(false);

  useEffect(() => {
    if (!deleteModal && !favServicesModal) {
      getCompanies({
        page: pagination?.page,
        pageSize: pagination?.pageSize,
        searchValue,
      });
      setRecord({});
      setRowId('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handelAdd, deleteModal, favServicesModal]);

  const getCompanies = async ({ page, pageSize, searchValue }) => {
    setLoading(true);
    try {
      let url = '/businessCompany/get';
      const res = await axios.post(
        urldashboard + url,
        JSON.stringify({ page, pageSize, search: searchValue }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      const data = await res.data;
      setHeaders(data?.headers?.map((item) => item.label));
      const items = data?.data?.map((obj) => ({ ...obj, key: obj.id }));
      setData(items);
      setTotalRecord(data?.totalRecord);
      setPagination({
        page: page,
        pageSize: pageSize,
        total: data?.totalRecord,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setData([]);
    }
  };

  const handlePagination = (newPage, newPageSize) => {
    getCompanies({
      page: newPage,
      pageSize: newPageSize,
      searchValue,
    });
  };

  const search = () => {
    getCompanies({
      page: 1,
      pageSize: 10,
      searchValue,
    });
  };

  const columns = [
    {
      title: 'ردیف',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg'],
      render: (_, record, index) => (
        <>{index + 1 + (pagination?.page - 1) * pagination?.pageSize}</>
      ),
    },
    {
      title: 'عملیات',
      key: 'actions',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (_, record) => (
        <Dropdown>
          <Dropdown.Toggle
            style={{ backgroundColor: '#464dee', color: '#ffffff' }}
          ></Dropdown.Toggle>

          <Dropdown.Menu id={record?.id} align={'right'}>
            <Dropdown.Item
              className={'d-inline-flex'}
              onClick={() => navigateToAddresses(record?.id, record?.name)}
            >
              آدرسها
            </Dropdown.Item>
            <Dropdown.Item
              className={'d-inline-flex'}
              onClick={() => navigateToUsers(record?.id, record?.name)}
            >
              کاربران
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      ),
    },
    {
      title: 'نام شرکت',
      dataIndex: 'name',
      key: 'name',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
    },
    {
      title: 'نام نماینده',
      dataIndex: 'responsibleUserFullName',
      key: 'responsibleUserFullName',
      responsive: ['xl', 'lg', 'md'],
    },
    {
      title: 'شماره موبایل نماینده',
      dataIndex: 'responsibleUserPhoneNumber',
      key: 'responsibleUserPhoneNumber',
      responsive: ['xl', 'lg', 'md'],
    },
    {
      title: 'ویرایش',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (_, record) => (
        <Button onClick={() => handleEditbtn(record?.id)}>
          <i className='mdi mdi-pencil' style={{ fontSize: '1rem' }}></i>
        </Button>
      ),
    },
    {
      title: 'حذف',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (_, record) => (
        <Button onClick={() => handleDelete(record?.id)}>
          <i className='mdi mdi-delete' style={{ fontSize: '1rem' }}></i>
        </Button>
      ),
    },
    {
      title: 'خدمات مورد علاقه',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (_, record) => (
        <Button onClick={() => showFavServices(record)}>
          <i className='mdi mdi-star' style={{ fontSize: '1rem' }}></i>
        </Button>
      ),
    },
  ];

  const handleEditbtn = (id) => {
    handelAdd(true);
    handelEdit(id);
  };

  const handleDelete = (id) => {
    setRowId(id);
    setDeleteModal(true);
  };

  const favServicesColumns = [
    {
      title: 'مورد علاقه',
      dataIndex: 'isSelect',
      key: 'isSelect',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (value, record) => (
        <Checkbox
          defaultChecked={value}
          disabled={value}
          onChange={() => onSelectChange(record?.key)}
        />
      ),
    },
    {
      title: 'خدمت',
      dataIndex: 'value',
      key: 'value',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
    },
  ];

  const showFavServices = async (record) => {
    setRecord(record);
    setRowId(record?.id);
    setFavServicesLoading(true);
    try {
      let url = `/B2BGroup/get/${record?.id}`;
      const response = await axios.get(urldashboard + url, {
        headers: {
          Authorization: authentication,
          'Content-Type': 'application/json',
        },
      });
      const data = await response?.data?.data;
      setFavServices(data);
      setFavServicesModal(true);
      setFavServicesLoading(false);
    } catch (error) {
      handelerrors(error);
      setFavServicesLoading(false);
    }
  };

  const onSelectChange = (rowId) => {
    favServices?.forEach((element, index) => {
      if (element?.key === rowId) {
        favServices[index].isSelect = !favServices[index].isSelect;
      }
    });
  };

  const submitFavServices = async () => {
    setSubmitFavServicesLoading(true);
    try {
      let url = '/B2BGroup/set';
      const response = await axios.post(
        urldashboard + url,
        JSON.stringify({
          groupIds: favServices
            ?.filter((item) => item.isSelect)
            ?.map((service) => {
              return service?.key;
            }),
          companyId: rowId,
        }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      toaster.success(response?.data?.message);
      setSubmitFavServicesLoading(false);
      setFavServicesModal(false);
    } catch (error) {
      handelerrors(error);
      setSubmitFavServicesLoading(false);
      setFavServicesModal(false);
    }
  };

  const navigateToAddresses = (id, name) => {
    history.push('/B2BAddress', { id, name });
  };

  const navigateToUsers = (id, name) => {
    history.push('/B2BUser', { id, name });
  };

  return (
    <>
      <CreateCancel />
      {SohwaddFrom ? (
        <div
          style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '15px',
          }}
        >
          <FormBusinessCompany />
        </div>
      ) : (
        <>
          <Row
            gutter={20}
            style={{
              marginTop: 25,
            }}
          >
            <Col xs={24} sm={24} md={24} lg={12} style={{ marginBottom: 20 }}>
              <InputGroup>
                <Input
                  placeholder='جستجوی سریع (نام شرکت)'
                  name='searchValue'
                  onChange={(e) => setSearchValue(e.target.value)}
                  style={{
                    height: '3rem',
                    width: '90%',
                    display: 'table-cell',
                  }}
                />
                <Button
                  onClick={search}
                  style={{
                    height: '3rem',
                    width: '10%',
                    display: 'table-cell',
                    padding: 0,
                  }}
                >
                  <i className='mdi mdi-magnify'></i>
                </Button>
              </InputGroup>
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} style={{ marginBottom: 20 }}>
              <Space
                wrap
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  width: '100%',
                }}
              >
                <Excel data={data} headers={headers} fileName={'شرکتها'} />
              </Space>
            </Col>
          </Row>

          <Table
            size='small'
            style={{ textAlign: 'right', marginTop: 10 }}
            rowClassName={() => 'center'}
            columns={columns}
            bordered={true}
            dataSource={data}
            loading={loading}
            pagination={false}
            locale={{
              emptyText: 'موردی یافت نشد',
            }}
          />

          {!loading && (
            <CustomPagination
              totalRecord={totalRecord}
              pagination={pagination}
              handlePagination={handlePagination}
              notMain
            />
          )}

          {deleteModal && (
            <ModalDelete
              showitem={deleteModal}
              handleCloseMoudal={() => setDeleteModal(false)}
              id={rowId}
            />
          )}

          {favServicesModal && (
            <Modal
              title={
                <div className='d-flex justify-content-between align-items-center'>
                  <div>
                    <span style={{ color: '#939393' }}>
                      خدمات مورد علاقه شرکت{' '}
                    </span>
                    <span style={{ color: '#000000' }}>{record?.name}</span>
                  </div>
                  <Button
                    key='back'
                    type='link'
                    onClick={() => setFavServicesModal(false)}
                  >
                    <i
                      className='mdi mdi-close'
                      style={{ fontSize: '1rem', color: '#939393' }}
                    ></i>
                  </Button>
                </div>
              }
              open={favServicesModal}
              onCancel={() => setFavServicesModal(false)}
              closable={false}
              footer={[
                <Button
                  block
                  key='submit'
                  type={'primary'}
                  loading={submitFavServicesLoading}
                  onClick={() => submitFavServices()}
                >
                  ثبت
                </Button>,
              ]}
              bodyStyle={{ maxHeight: 600, overflowY: 'auto' }}
            >
              <Table
                size='small'
                rowClassName={() => 'center'}
                columns={favServicesColumns}
                bordered={true}
                dataSource={favServices}
                loading={favServicesLoading}
                pagination={false}
                locale={{
                  emptyText: 'موردی یافت نشد',
                }}
              />
            </Modal>
          )}
        </>
      )}
    </>
  );
}
